import { commonService } from '../../_services'
const questionService = commonService('api/v1/question')

export const questions = {
  namespaced: true,
  state: {
    all: { items: [] },
    loading: false,
  },
  actions: {
    async getAll(context: any): Promise<void> {
      context.commit('GET_ALL_REQUEST')

      return questionService.getAll().then((resp) => {
        context.commit('GET_ALL_SUCCESS', resp.data)
      }).catch(errorMsg => {
        context.commit('GET_ALL_FAILURE')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
      })
    },
    async addOne(context: any, data: any): Promise<void> {
      context.commit('ADD_REQUEST')

      return questionService.addOne(data).then((resp) => {
        // Fetch just added data
        questionService.getOne(resp.data._id).then(singleData => {
          context.commit('ADD_ITEM_SUCCESS', singleData.data)
        })
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async updateOne(context: any, data: any): Promise<void> {
      context.commit('UPDATE_REQUEST')

      return questionService.updateOne(data).then((resp) => {
        context.commit('UPDATE_ITEM_SUCCESS', data)
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async deleteOne(context: any, item: any): Promise<void> {
      context.commit('DELETE_REQUEST')
      return questionService.deleteOne(item._id).then((resp) => {
        context.commit('DELETE_ITEM_SUCCESS', item)
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    }
  },
  mutations: {
    GET_ALL_REQUEST(state: any) {
      state.loading = true
    },
    GET_ALL_SUCCESS(state: any, allItems: any[]) {
      allItems.map(item => {
        return item
      })

      state.all = { items: allItems }
      state.loading = false
    },
    GET_ALL_FAILURE(state: any) {
      state.all = { items: [] }
      state.loading = false
    },
    GET_REQUEST(state: any) {
      state.loading = true
    },
    ADD_REQUEST(state: any) {
      state.loading = true
    },
    UPDATE_REQUEST(state: any) {
      state.loading = true
    },
    DELETE_REQUEST(state: any) {
      state.loading = true
    },
    ADD_ITEM_SUCCESS(state: any, item: any) {
      state.all.items.push(item)
      state.loading = false
    },
    UPDATE_ITEM_SUCCESS(state: any, item: any) {
      state.all.items = state.all.items.map(tmp => {
        return tmp._id === item._id ? item : tmp
      })

      state.loading = false
    },
    DELETE_ITEM_SUCCESS(state: any, item: any) {
      const index = state.all.items.indexOf(item)
      state.all.items.splice(index, 1)
      state.loading = false
    },
    REQUEST_ERROR(state: any) {
      state.loading = false
    }
  },
  getters: {
    canEdit: state => () => {
      return questionService.canEdit()
    },
    canDelete: state => () => {
      return questionService.canDelete()
    }
  },
}
